(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationAddTraveler',
	};

	var $form;

	var _vendorRecommendedTravelers;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		Adzuki.Erez.SearchAddTraveler.init(form.name);

		// Toggle client opportunity typeahead
		$form.find('.vendor-selection').on('change', function change(e) {
			_vendorRecommendedTravelers($(this).val());
		});

		if ($('#reservationaddtraveler-reservation_vendor_id').length > 0) {
			_vendorRecommendedTravelers($('#reservationaddtraveler-reservation_vendor_id').val());
		} else if ($form.find('input[name=form_component_data\\[ReservationAddTraveler\\]\\[reservation_vendor_id\\]]:checked').length > 0) {
			_vendorRecommendedTravelers($form.find('input[name=form_component_data\\[ReservationAddTraveler\\]\\[reservation_vendor_id\\]]:checked').val());
		}

		// Submit form when Save and Continue is clicked
		$('.add-traveler-submit').on('click', function click(e) {
			var $target = $(e.target);

			$form.find('.selected-vendor-box').removeClass('error');
			$('.selected-travelers-box').removeClass('error');

			$target.addClass('disabled');
			$target.next().css('visibility', 'visible');
			$form.submit();
		});
	};

	form.success = function success(response)
	{
		var $add_traveler_submit = $('.add-traveler-submit');

		if (!Adzuki.Form.hasError(response)) {
			window.location.href = response['data'];
			return true;
		}

		if (response['status'] === 'validation_error') {
			$.each(response['data'], function iterator(i, error_data) {
				if ('errors' in error_data) {
					if (error_data['errors'][0].substr(0, 7) === 'Vendor ') {
						$form.find('.selected-vendor-box').addClass('error');
					} else if (error_data['errors'][0].substr(0, 19) === 'Selected Travelers ' || error_data['errors'][0].match(' is already on this ')) {
						$('.selected-travelers-box').addClass('error');
					}
				}
			});
		}

		$add_traveler_submit.next().css('visibility', 'hidden');
		$add_traveler_submit.removeClass('disabled');

		return false;
	};

	_vendorRecommendedTravelers = function _vendorRecommendedTravelers(reservation_vendor_id)
	{
		// eslint-disable-next-line no-negated-condition
		if (typeof reservation_vendor_id !== 'undefined') {
			Adzuki.Ajax.get('/Reservations/getRecommendedTravelers/reservation_vendor/' + reservation_vendor_id).then(function success(recommended_travelers) {
				Adzuki.Erez.SearchAddTraveler.buildRecommendedTravelers(recommended_travelers);
			});
		} else {
			Adzuki.Erez.SearchAddTraveler.resetRecommendedTravelers();
		}
	};

}(jQuery, window.Adzuki || {}));
